import { TableHead, TableHeader, TableRow } from '@/components/ui';
import { TableHeadSortable } from '@/components/custom';
import { ITransaction } from '@/interfaces';
import { nameof } from '@/functions';

export const DataTableHeader = () => (
    <TableHeader>
        <TableRow>
            <TableHeadSortable
                className="w-[110px]"
                name={nameof<ITransaction>('occurredAt')}
                text="Date" />
            <TableHeadSortable
                className="w-[100px]"
                name={nameof<ITransaction>('type')}
                text="Type" />
            <TableHeadSortable
                className="w-[140px]"
                name={nameof<ITransaction>('category')}
                text="Catégorie" />
            <TableHeadSortable
                className="w-[130px]"
                name={nameof<ITransaction>('amountEur')}
                text="Montant"
                classNameContent="justify-start" />
            <TableHead>
                Description
            </TableHead>
            <TableHead className="w-[90px] text-right">
                Actions
            </TableHead>
        </TableRow>
    </TableHeader>
);

export default DataTableHeader;
